import React from 'react';

function MainText(props){
return(
    <div 
    className='mainText'
    >
        
        <span>
        Welcome to the Movie Search App. 
        </span>
        
        <h1>Search movies in the Search-Bar.</h1>
        <h2>Add or Remove movies from favourites by clicking on the Heart-Icon.</h2>
    </div>
)
}

export default MainText;